import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const originalEmailActions = createActions(
  {
    ORIGINAL_EMAIL_GET: [
      (payload: any) => payload, // Payload
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    ORIGINAL_EMAIL_GET_HTML_MESSAGE: [
      (payload: any) => payload, // Payload
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    ORIGINAL_EMAIL_HTML_GET_BY_TYPE: [
      (payload: any) => payload, // Payload
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    ORIGINAL_EMAIL_GET_PRINTER_FRIENDLY: [
      (payload: any) => payload, // Payload
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
  },

  'ORIGINAL_EMAIL_GET_SUCCEEDED',
  'ORIGINAL_EMAIL_GET_FAILED',

  'ORIGINAL_EMAIL_GET_HTML_MESSAGE_SUCCEEDED',
  'ORIGINAL_EMAIL_GET_HTML_MESSAGE_FAILED',

  'ORIGINAL_EMAIL_HTML_GET_BY_TYPE_SUCCEEDED',
  'ORIGINAL_EMAIL_HTML_GET_BY_TYPE_FAILED',

  'ORIGINAL_EMAIL_GET_PRINTER_FRIENDLY_SUCCEEDED',
  'ORIGINAL_EMAIL_GET_PRINTER_FRIENDLY_FAILED',

  'ORIGINAL_EMAIL_CLOSE_MODAL',
);
